'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('../../styles/styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by sbardian on 5/18/17.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var Choices = function (_React$Component) {
  _inherits(Choices, _React$Component);

  function Choices(props) {
    _classCallCheck(this, Choices);

    var _this = _possibleConstructorReturn(this, (Choices.__proto__ || Object.getPrototypeOf(Choices)).call(this, props));

    _this.state = {
      correct_answer: _this.props.correct_answer,
      incorrect_answers: _this.props.incorrect_answers
    };
    return _this;
  }

  // Shuffles the answers array to displace the correct answer


  _createClass(Choices, [{
    key: 'shuffle',
    value: function shuffle(a) {
      var j = void 0,
          x = void 0,
          i = void 0;
      for (var _i = a.length; _i; _i--) {
        var _j = Math.floor(Math.random() * _i);
        var _ref = [a[_j], a[_i - 1]];
        a[_i - 1] = _ref[0];
        a[_j] = _ref[1];
      }
      return a;
    }

    // Combines the correct and incorrect answers into one array

  }, {
    key: 'createAnswers',
    value: function createAnswers() {
      var answers = [];
      var i = 0;
      this.props.incorrect_answers.map(function (ans) {
        //answers.push(ans);
        answers[i] = ans;
        i++;
      });
      answers.push(this.props.correct_answer);
      return answers = this.shuffle(answers);
    }
  }, {
    key: 'htmlDecode',
    value: function htmlDecode(input) {
      var e = document.createElement('div');
      e.innerHTML = input;
      return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }
  }, {
    key: 'clickHandler',
    value: function clickHandler(i, ans) {
      this.props.answerSelectedClicked ? this.props.answerSelectedClicked(i, ans) : console.log('Answer selected = ', ans);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var answers = this.createAnswers();
      return _react2.default.createElement(
        'ul',
        { style: _styles2.default.cardList },

        // TODO: Call to CHOICES passing correct and incorrect.
        answers.map(function (ans, i) {
          return _react2.default.createElement(
            'li',
            {
              style: _styles2.default.answers,
              className: "otAnswer",
              id: "ot-answer-" + i,
              onClick: _this2.clickHandler.bind(_this2, i, ans),
              key: ans
            },
            _react2.default.createElement(
              'h4',
              null,
              _this2.htmlDecode(ans)
            )
          );
        })
      );
    }
  }]);

  return Choices;
}(_react2.default.Component);

exports.default = Choices;


Choices.propTypes = {
  correct_answer: _propTypes2.default.string,
  incorrect_answers: _propTypes2.default.array,
  answerSelectedClicked: _propTypes2.default.func
};

Choices.defaultProps = {
  correct_answer: '',
  incorrect_answers: [],
  answerSelectedClicked: null
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /Users/sbardian/WebstormProjects/Reactjs/opentrivia-react/lib/components/Choices.js
// module id = 167
// module chunks = 0